import React from 'react';
import DealBanner from '../../DealBanner';
import { PlansDealBannerProps } from '../../../types/plans';
import { ComposerBlockElement } from '../../../types/composer';

type Props = {
  plansPage?: PlansDealBannerProps;
};

/**
 * Display deal banner component.
 */
const DealBannerBlock: ComposerBlockElement = (props: Props) => {
  const { plansPage } = props;
  return plansPage ? <DealBanner plansPage={plansPage} /> : <></>;
};

DealBannerBlock.schema = {
  name: 'deal-banner',
  label: 'Deal Banner',
};

export default DealBannerBlock;
